import { useAuth } from 'react-oidc-context';
import {
  useQuery,
  QueryKey,
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  MutationFunction,
  UseMutationOptions,
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query';
import { OpenAPI } from 'data/openapi';
import type { AxiosError } from 'axios';

type CustomError = {
  body?: {
    fieldErrors?: Record<string, string>;
    globalErrors?: Record<string, string>;
    errors?: Array<string>;
    // TBD
    ledgerApiError?: any;
  };
};

const useCustomQuery = <TQueryFnData = unknown, TError = AxiosError & Error & CustomError, TData = TQueryFnData>(
  queryKey: QueryKey,
  queryFn: QueryFunction<TQueryFnData, QueryKey>,
  options: UseQueryOptions<TQueryFnData, TError, TData> = {},
): UseQueryResult<TData, TError> => {
  const { user } = useAuth();
  return useQuery(
    queryKey,
    async (...args) => {
      // if token expiration time less then 60 second, do update token
      // await keycloak.updateToken(60);
      OpenAPI.TOKEN = user?.access_token;
      // TODO
      // await auth.signinSilent({ max_age: auth.user?.expires_at });

      return queryFn(...args);
    },
    options,
  );
};

const useCustomMutation = <
  TData = unknown,
  TError = AxiosError & Error & CustomError,
  TVariables = void,
  TContext = unknown,
>(
  mutationFn: MutationFunction<TData, TVariables>,
  options?: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationResult<TData, TError, TVariables, TContext> => {
  const { user } = useAuth();
  return useMutation(async (...args) => {
    OpenAPI.TOKEN = user?.access_token;

    return mutationFn(...args);
  }, options);
};

export { useCustomQuery as useQuery, useCustomMutation as useMutation };
